import React, { ReactNode } from 'react'
import { Link } from 'gatsby'

type TileLinkWrapperProps = {
  children: ReactNode
  className?: string
  isLinkExternal: boolean
  linkTo: string
}

export const TileLinkWrapper = ({
  children,
  isLinkExternal,
  className,
  linkTo,
}: TileLinkWrapperProps) => {
  return isLinkExternal ? (
    <a href={linkTo} className={className}>
      {children}
    </a>
  ) : (
    <Link to={linkTo} className={className}>
      {children}
    </Link>
  )
}
